import React from 'react';

export const BlueDotIcon = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Beta-CAJA--—-EDITS/-HELP/-ERRORS.-LW"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Beta--Classify-VD" transform="translate(-193.000000, -131.000000)">
        ß
        <g id="Header-">
          <g id="Progress-bar-" transform="translate(0.000000, 68.000000)">
            <g id="Group-2-Copy" transform="translate(176.000000, 62.000000)">
              <g id="plus" transform="translate(0.000000, 1.000000)">
                <g id="now" transform="translate(17.000000, 0.000000)">
                  <g id="Group-7">
                    <circle
                      id="Oval-Copy-135"
                      stroke="#2765CF"
                      strokeWidth="3"
                      fill="#FFFFFF"
                      cx="12"
                      cy="12"
                      r="10.5"
                    />
                    <circle
                      id="Oval-Copy-135"
                      fill="#2765CF"
                      cx="12"
                      cy="12"
                      r="6"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
